"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PDFPreview = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_components_1 = __importDefault(require("styled-components"));
const theme_1 = require("../../theme");
/**
 * Renders a PDF in an iframe.
 * Pass either a `file` (File object) or a `url` (string).
 * Object URLs created from `file` are revoked automatically on cleanup.
 */
const PDFPreview = ({ file, url: externalUrl, width = 600, height = 600, smallHeight = 300, }) => {
    const [objectUrl, setObjectUrl] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        if (!file) {
            setObjectUrl(null);
            return;
        }
        const url = URL.createObjectURL(file);
        setObjectUrl(url);
        return () => {
            URL.revokeObjectURL(url);
        };
    }, [file]);
    const rawSrc = objectUrl ?? externalUrl ?? null;
    const src = rawSrc ? `${rawSrc}#view=FitH` : null;
    if (!src)
        return null;
    return ((0, jsx_runtime_1.jsx)(PreviewWrapper, { "$width": width, "$height": height, "$smallHeight": smallHeight, children: (0, jsx_runtime_1.jsx)("iframe", { src: src, width: "100%", height: "100%", title: "PDF Preview", style: { border: "none", display: "block" } }) }));
};
exports.PDFPreview = PDFPreview;
const PreviewWrapper = styled_components_1.default.div `
  width: 100%;
  height: ${({ $smallHeight }) => typeof $smallHeight === "number" ? `${$smallHeight}px` : $smallHeight};

  @media (min-width: ${theme_1.breakpoints.tablet}px) {
    width: ${({ $width }) => typeof $width === "number" ? `${$width}px` : $width};
    height: ${({ $height }) => typeof $height === "number" ? `${$height}px` : $height};
  }
`;
